var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.eventClass,style:(_vm.background)},[(_vm.election.title.rendered)?_c('div',{staticClass:"inner-content"},[_c('Alert'),_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }